import { NavBar, Toast, Image, Grid, Button, Badge, Card, Dialog, Space, List, Input } from 'antd-mobile'
import React, { useCallback, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import Icon from '../../icon';
import '../index.css';
import { useAuth } from '../../app/providers/AuthProvider';
import { gameYearApi } from '../../features/game-year/api/gameYearApi';
export default function LittleGameInfo() {

    const { memberInfo } = useAuth()

    const location = useLocation();
    const gameYearId = location.state.yearId;
    const gameType = location.state.gameType;

    const [userListInfo, setUserListInfo] = useState([])

    const getGameDetail = useCallback(() => {
        Toast.show({
            icon: 'loading',
            duration: 0,
        })
        gameYearApi.getLittleGame(gameYearId, gameType)
            .then(function (response) {
                const detailData = response.data.data
                setUserListInfo(detailData)
            })
            .catch(function (error) {
                Toast.show({
                    icon: 'fail',
                    content: '服务错误！请联系管理员！'
                })
            })
            .finally(() => {
                Toast.clear()
            });
    }, [gameType, gameYearId])

    useEffect(() => {
        getGameDetail()
    }, [getGameDetail]);

    return (
        <div className="game-year-container has-unified-nav">
            <NavBar
                className="unified-navbar fixed"
                onBack={() => window.history.back()}
            >
                <span>
                    {gameType === 1 ? (<>
                        折返跑记录
                    </>)
                        : gameType === 2 ? (<>
                            开大脚记录
                        </>)
                            : (<>
                                手抛球记录
                            </>)
                    }
                </span>
            </NavBar>
            <div className='info_detail' style={{ padding: '16px 10px' }}>
                <Card>
                    <Grid columns={3}>
                        <Grid.Item style={{ display: "flex", justifyContent: 'center' }}>姓名</Grid.Item>
                        <Grid.Item style={{ display: "flex", justifyContent: 'center' }}>成绩</Grid.Item>
                        {(memberInfo.admin === 1 || memberInfo.standingMember > 0) &&
                            <Grid.Item style={{ display: "flex", justifyContent: 'center' }}>操作</Grid.Item>
                        }
                    </Grid>
                    <List>
                        {userListInfo?.map((item, index) => (
                            <div>
                                <List.Item key={index}>

                                    <Grid columns={3}>
                                        <Grid.Item>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <span style={{ width: '26px' }}>
                                                    {index + 1}
                                                </span>
                                                <Badge>
                                                    <Image
                                                        src={item.memberHeadImg + Icon.ImageFooter}
                                                        width={30}
                                                        height={30}
                                                        fit='cover'
                                                        style={{ borderRadius: '50%', border: '1px solid #ebeeef' }}
                                                    />
                                                </Badge>
                                                <span style={{ fontSize: '12px', marginLeft: '10px', fontWeight: 'bold' }}>{item.memberName}</span>
                                            </div>
                                        </Grid.Item>
                                        <Grid.Item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            {item.gameGoal ?? "-"}
                                        </Grid.Item>
                                        {(memberInfo.admin === 1 || memberInfo.standingMember > 0) &&
                                            <Grid.Item>
                                                <Space style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <Button
                                                        size='small'
                                                        color='primary'
                                                        onClick={() => {
                                                            let grade;
                                                            Dialog.confirm({
                                                                title: "记录" + item.memberName + "的" + (gameType === 1 ? "折返跑记录" : gameType === 2 ? "开大脚记录" : "手抛球记录"),
                                                                content: (
                                                                    <div>
                                                                        <Input placeholder="请输入成绩" onChange={value =>
                                                                            grade = value} />
                                                                    </div>
                                                                ),
                                                                onConfirm: () => {
                                                                    gameYearApi.saveLittleRecord({
                                                                        gameYearId: gameYearId,
                                                                        gameType: gameType,
                                                                        memberId: item.memberId,
                                                                        recordInfo: grade
                                                                    })
                                                                        .then(function (response) {
                                                                            if (response.data.code === 200) {
                                                                                Toast.show({
                                                                                    content: '创建成功！',
                                                                                    icon: 'success',
                                                                                })
                                                                                getGameDetail()
                                                                            } else {
                                                                                Toast.show({
                                                                                    content: response.data.msg,
                                                                                    icon: 'fail',
                                                                                    afterClose: () => {
                                                                                        window.history.back()
                                                                                    },
                                                                                })
                                                                            }
                                                                        })
                                                                        .catch(function (error) {
                                                                            Toast.show({
                                                                                content: '创建失败,请重试!',
                                                                                icon: 'fail'
                                                                            })
                                                                        })
                                                                        .finally(() => {
                                                                        });
                                                                }
                                                            })
                                                        }}
                                                        style={{ fontSize: '12px' }}
                                                    >
                                                        记录成绩
                                                    </Button>
                                                </Space>
                                            </Grid.Item>
                                        }
                                    </Grid>
                                </List.Item>
                            </div>
                        ))}
                    </List>
                </Card>
            </div>
        </div>
    )
}
